var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.07471C26.1217 8.07471 28.1566 8.91756 29.6568 10.4179C31.1571 11.9181 32 13.953 32 16.0747C32 18.1964 31.1571 20.2313 29.6568 21.7316C28.1566 23.2319 26.1217 24.0747 24 24.0747C21.8783 24.0747 19.8434 23.2319 18.3431 21.7316C16.8428 20.2313 16 18.1964 16 16.0747C16 13.953 16.8428 11.9181 18.3431 10.4179C19.8434 8.91756 21.8783 8.07471 24 8.07471ZM24 12.0747C22.9391 12.0747 21.9217 12.4961 21.1716 13.2463C20.4214 13.9964 20 15.0138 20 16.0747C20 17.1356 20.4214 18.153 21.1716 18.9031C21.9217 19.6533 22.9391 20.0747 24 20.0747C25.0609 20.0747 26.0783 19.6533 26.8284 18.9031C27.5786 18.153 28 17.1356 28 16.0747C28 15.0138 27.5786 13.9964 26.8284 13.2463C26.0783 12.4961 25.0609 12.0747 24 12.0747ZM24 26.0747C29.34 26.0747 40 28.7347 40 34.0747V40.0747H7.99999V34.0747C7.99999 28.7347 18.66 26.0747 24 26.0747ZM24 29.8747C18.06 29.8747 11.8 32.7947 11.8 34.0747V36.2747H36.2V34.0747C36.2 32.7947 29.94 29.8747 24 29.8747Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.fd7799239f8369d5b7e665ff32694279.svg";
export { ForwardRef as ReactComponent };